import { ReactNode } from 'react';
import { Button, Modal } from 'semantic-ui-react';

type ConfirmModalProps = {
    msg: string;
    onConfirm: () => void;
    onCancel: () => void;
    className?: string;
    children?: ReactNode;
    open?: boolean;
};

function ConfirmationModal({ msg, onCancel, onConfirm, className = '', children, open = true }: ConfirmModalProps) {
    return (
        <Modal open={open} size="small">
            <Modal.Header>Confirmation</Modal.Header>
            <Modal.Content className={className}>
                <p>{msg}</p>
                {children}
            </Modal.Content>
            <Modal.Actions>
                <Button size="mini" color="red" onClick={onConfirm}>
                    Confirm
                </Button>
                <Button size="mini" onClick={onCancel}>
                    Cancel
                </Button>
            </Modal.Actions>
        </Modal>
    );
}

export default ConfirmationModal;
